Vendd.Scripts.load(function () {

    var cartModel = null;

	Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-version-selector-sku-table', function (envelope) {

		var $context = envelope.message.data.context,
			$controls = $('.x-product-details-version-selector.sku-table', $context);

		if ($controls.length < 1) return;

		$.each($controls, function (i, control) {
            var $control = $(control);

            control.loading = function (load) {
                if (load) {
                    $control.addClass('x-loading');
                } else {
                    $control.removeClass('x-loading');
                }
            };

            control.skuLoading = function (sku, load) {
                if (load) {
                    sku.addClass('x-loading');
                } else {
                    sku.removeClass('x-loading');
                }
            };

            control.update = function () {
                var $productBoxes = $('.x-product-variant-box', $control);

                $productBoxes.each(function (j, productBox) {
                    var $productBox = $(productBox), cartId, quantity;
                    var unitPrice = $productBox.data('unit-price');
                    var min = 0; //always zero
                    var max = $productBox.data('max-quantity');

                    //update cart id
                    cartId = control.getCartId($productBox);
                    $productBox.attr('data-cartproductid', cartId);

                    //update quantity
                    quantity = control.getCartQty($productBox);
                    control.updateQuantity($productBox, quantity, min, max);

                    //update unit price
                    control.updateUnitPrice($productBox, unitPrice);

                    //update total price
                    control.updateTotalPrice($productBox, unitPrice, quantity);

                    //remove loader
                    control.skuLoading($productBox, false);
                });

                control.loading(false);
            };

            control.updateQuantity = function (productBox, quantity, min, max) {
                $('.js-qty-input', productBox).val(quantity);

                if (productBox.hasClass('x-disabled')) {
                    $('.js-qty-decr, .js-qty-incr', productBox).addClass('disabled');
                } else {
                    if (quantity <= min) {
                        $('.js-qty-decr', productBox).addClass('disabled');
                    }
                    if (quantity >= max) {
                        $('.js-qty-incr', productBox).addClass('disabled');
                    }  
                } 
            };

            control.updateUnitPrice = function (productBox, unitPrice) {
                $('.js-unit-price-value', productBox).text(unitPrice);
                $('.js-unit-price', productBox).toggleClass('unit-price-visible', unitPrice > 0);
            };

            control.updateTotalPrice = function (productBox, unitPrice, quantity) {
                var totalPrice = NumberFormatter.parsePrice(unitPrice);
                totalPrice = totalPrice * quantity;
                totalPrice = NumberFormatter.formatPrice(totalPrice);
                $('.js-total-price-value', productBox).text(totalPrice);
                $('.js-total-price', productBox).toggleClass('total-price-visible', totalPrice.length > 0);
            };

            control.getCartId = function (productBox) {
                var item = cartModel.Items.find(function (x) { return x.VariantId == productBox.data('variantid'); });
                return item ? item.Id : 0;
            };

            control.getCartQty = function (productBox) {
                var item = cartModel.Items.find(function (x) { return x.VariantId == productBox.data('variantid'); });
                return item ? item.Quantity : 0;
            };

            control.addToCart = function (productBox, quantity) {
                var data = {
                    cartId: parseInt(productBox.attr('data-cartproductid')),
                    id: parseInt(productBox.attr('data-productid')),
                    skuId: parseInt(productBox.attr('data-variantid')),
                    path: parseInt(productBox.attr('data-path')),
                    qty: quantity,
                    extraAttributes: [],
                    bundleItems: [],
                    itemInfo: {
                        minQuantity: parseInt(productBox.attr('data-min-quantity')),
                        maxQuantity: parseInt(productBox.attr('data-max-quantity')),
                        quanta: parseInt(productBox.attr('data-quanta'))
                    }
                };

                // if quantity has not changed
                var cartQuantity = control.getCartQty(productBox);
                if (cartQuantity == quantity) {
                    control.skuLoading(productBox, false);
                    return;
                }

                //if product exists in cart
                if (data.cartId != 0) {
                    if (data.qty == 0) {
                        Vendd.MessageBus.publishAsync(productBox, new Vendd.Cart.Messages.MultipleRemove([data.cartId]));

                        Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, productBox, function (envelope) {
                            toastr.success(envelope.message.data.data.SuccessMessage, "", { timeOut: 1200, showDuration: 1000, hideDuration: 700 });
                            Vendd.MessageBus.unsubscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, productBox);
                       });
                    } else {
                        Vendd.MessageBus.publishAsync(productBox, new Vendd.Cart.Messages.SetQuantity(data.cartId, data.qty));

                        Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetQuantitySuccess, productBox, function (envelope) {
                            if (envelope.message.data.code === "OperationSuccesful") {
                                toastr.success(envelope.message.data.data.Messages[0], "", { timeOut: 1200, showDuration: 1000, hideDuration: 700 });
                            } else {
                                toastr.warning(envelope.message.data.data.Messages[0], "", { timeOut: 1200, showDuration: 1000, hideDuration: 700 });
                            }
                            
                            Vendd.MessageBus.unsubscribe(Vendd.Cart.Messages.SetQuantitySuccess, productBox);
                        });
                    }
                } else {
                    if (data.qty != 0) {
                        Vendd.MessageBus.publishAsync(productBox, new Vendd.Cart.Messages.Add(data.id, data.skuId, data.path, data.qty, data.extraAttributes, data.bundleItems, data.itemInfo));
                    } else {
                        control.skuLoading(productBox, false);
                        return;
                    }
                }
            };

            $control.on('click', '.js-qty-change', function (e) {
                var $this = $(this);

                if ($this.hasClass('disabled')) return;

                var $productBox = $this.closest(".x-product-variant-box");
                var $spinner = $this.parent();
                var $input = $this.siblings('input').eq(0);
                var val = ($input.val() ? stringToNumber($input.val()) : null) || 0;
                var min = 0; // ignore data-min-quantity - always zero
                var max = ($productBox.attr("data-max-quantity") ? stringToNumber($productBox.attr("data-max-quantity")) : null) || 100000;
                var quanta = ($productBox.attr("data-quanta") ? stringToNumber($productBox.attr("data-quanta")) : null) || 1;

                if (isNaN(val) || isNaN(min) || isNaN(max) || isNaN(quanta)) {
                    console.error('Error found in quantity selector\'s values');
                }

                if ($this.hasClass('js-qty-decr')) {

                    if (min === "" && max === "" && quanta === "") {
                        min = parseInt($spinner.data('min'));
                        max = parseInt($spinner.data('max'));
                        quanta = parseInt($spinner.data('quanta'));
                        val = parseInt(val) - parseInt(quanta);
                    }
                    else if (Vendd.Helpers.isInteger(parseFloat(quanta))) {
                        val = parseInt(val) - parseInt(quanta);
                    }
                    else if (parseFloat(val) > parseFloat(min) && (parseFloat(val) - parseFloat(quanta) >= parseFloat(min))) {
                        val = parseFloat(val) - parseFloat(quanta);
                        val = parseFloat(val).toFixed(2);
                    }
                    //$input.val(numberToString(val));
                    $this.siblings('.js-qty-incr').removeClass('disabled');
                    $this.siblings('.js-qty-incr').removeAttr('disabled');

                    if (parseFloat(val) === parseFloat(min)) {
                        $this.addClass('disabled');
                        $this.attr('disabled', 'disabled');
                    }
                } else if ($this.hasClass('js-qty-incr')) {

                    if (min === "" && max === "" && quanta === "") {
                        min = parseInt($spinner.data('min'));
                        max = parseInt($spinner.data('max'));
                        quanta = parseInt($spinner.data('quanta'));
                        val = parseInt(val) + parseInt(quanta);
                    }
                    else if (Vendd.Helpers.isInteger(parseFloat(quanta))) {
                        val = parseInt(val) + parseInt(quanta);
                    }
                    else if (parseFloat(val) < parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max)) && (parseFloat(val) + parseFloat(quanta)) <= parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max))) {
                        val = parseFloat(val) + parseFloat(quanta);
                        val = parseFloat(val).toFixed(2);
                    }

                    //$input.val(numberToString(val));
                    $this.siblings('.js-qty-decr').removeClass('disabled');
                    $this.siblings('.js-qty-decr').removeAttr('disabled');

                    if (parseFloat(val) === parseFloat(max)) {
                        $this.addClass('disabled');
                        $this.attr('disabled', 'disabled');

                    }
                }

                //show loader
                control.skuLoading($productBox, true);
                //add to cart
                control.addToCart($productBox, val);
            });

            $control.on('keyup', '.js-qty-input', function (e) {
                var $this = $(this);

                if ($this.hasClass('disabled')) return;

                var $productBox = $this.closest(".x-product-variant-box");
                var qty = $this.val() ? parseInt($this.val()) : 0;
                var min = 0; //ignore data-min-quantity - always zero
                var max = ($productBox.attr("data-max-quantity") ? parseInt($productBox.attr("data-max-quantity")) : null) || 100000;

                if (qty > min) {
                    $this.siblings('.js-qty-decr').removeClass('disabled');
                    $this.siblings('.js-qty-decr').removeAttr('disabled');
                }

                if (qty < max) {
                    $this.siblings('.js-qty-incr').removeClass('disabled');
                    $this.siblings('.js-qty-incr').removeAttr('disabled');
                }
            });

            $control.on('keydown', '.js-qty-input', function (e) {
                //on enter
                if (e.keyCode == 13) {
                    var $this = $(this);
                    var $productBox = $this.closest(".x-product-variant-box");
                    var val = $('.js-qty-input', $productBox).val();

                    //show loader
                    control.skuLoading($productBox, true);
                    //add to cart
                    control.addToCart($productBox, val);

                    return;
                }

                numbersOnly(e);
            });

            $control.on('blur', '.js-qty-input', function (e) {
                var $this = $(this);

                if ($this.hasClass('disabled')) return;

                var $productBox = $this.closest(".x-product-variant-box");
                var qty = ($this.val() ? parseInt($this.val()) : null) || 0;
                var min = 0; // ignore data-min-quantity - always zero
                var max = ($productBox.attr("data-max-quantity") ? parseInt($productBox.attr("data-max-quantity")) : null) || 100000;
                var quanta = ($productBox.attr("data-quanta") ? parseInt($productBox.attr("data-quanta")) : null) || 1;
                var unitType = $productBox.data('unit-type');

                if (isNaN(qty) || isNaN(min) || isNaN(max) || isNaN(quanta)) {
                    console.error('Error found in quantity selector\'s values');
                }

                if (qty >= min && (qty <= max || !max)) {
                    if (unitType === 'int') {
                        qty = parseInt(qty);
                        if (quanta) {
                            if (qty >= quanta) {
                                qty = Math.round(qty / quanta) * quanta;
                            } else {
                                qty = min;
                            }
                        }

                        $this.val(qty);
                    }
                    else if (unitType === 'decimal') {
                        qty = parseFloat(qty);
                        if (quanta) {
                            if (qty >= quanta) {
                                qty = Math.round(qty / quanta) * quanta;
                            } else {
                                qty = min;
                            }
                        }

                        $this.val(qty.toFixed(2));
                    }
                } else {
                    if (max && $this.val() > max) {
                        qty = max;
                        $this.val(qty);
                    } else {
                        if (min) {
                            qty = min;
                            $this.val(qty);
                        } else if (quanta) {
                            qty = quanta;
                            $this.val(qty);
                        } else {
                            qty = 0;
                            $this.val(0);
                        }
                    }
                }

                //show loader
                control.skuLoading($productBox, true);
                //add to cart
                control.addToCart($productBox, qty);
            });

            control.loading(true);

            if (cartModel) control.update();
        });
    });

    //Get cart model
    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, 'sku-table', function (envelope) {
        cartModel = envelope.message.data.Cart;

        var $controls = $('.x-product-details .x-product-details-version-selector.sku-table');

        $.each($controls, function (i, control) {
            control.update();
        });
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Warning, 'sku-table', function (envelope) {
        var $controls = $('.x-product-details .x-product-details-version-selector.sku-table');

        $.each($controls, function (i, control) {
            control.update();
        });
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, 'sku-table', function (envelope) {
        var $controls = $('.x-product-details .x-product-details-version-selector.sku-table');

        $.each($controls, function (i, control) {
            control.update();
        });
    });

});
